import classNames from 'classnames';
import styles from './BundleSelectorItem.scss';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { PresentationStyles, items } from '@wg/wows-entities/const';
import { playButtonClickSound } from '@wg/web2clientapi/sound';
import { CSSProperties } from 'react';

export interface IBundleSelectorItem {
    bundle: IBundle;
    isSelected: boolean;
    index: number;
    onClick: (n: number) => void;
}

const BundleSelectorItem = ({ bundle, isSelected, index, onClick }: IBundleSelectorItem) => {
    const isVehicle = bundle.primaryItem?.type === items.VEHICLES;
    const classesCard = classNames(styles.card, {
        [styles.selected]: isSelected,
    });

    const onClickHandler = () => {
        playButtonClickSound();
        onClick(index);
    };

    const style: CSSProperties = { animationDelay: `${(index + 1) * 100}ms` };

    return (
        <div className={classesCard} onClick={onClickHandler} style={style}>
            <div className={styles.background} style={{ backgroundImage: `url(${bundle.icons.medium})` }} />
            <div className={styles.header}>
                <div className={styles.title}>
                    {isVehicle ? (
                        <WoWSEntity
                            type={bundle.primaryItem.type}
                            id={bundle.primaryItem.identifier}
                            amount={bundle.primaryItem.amount}
                            presentation={{
                                renderWithoutFade: true,
                            }}
                        />
                    ) : (
                        <>{bundle.title}</>
                    )}
                </div>
                <div className={styles.subTitle}>
                    {isVehicle && (
                        <WoWSEntity
                            id={bundle.primaryItem.identifier}
                            type={items.VEHICLES}
                            key={`bundle_${bundle.id}_ship_${bundle.primaryItem.identifier}`}
                            presentation={{
                                style: PresentationStyles.TYPE,
                                renderWithoutFade: true,
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default BundleSelectorItem;
